const CTXT = '';

export const EVENT = `${CTXT}/api/event`;